(function () {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const cartEl = $('#hds-cart');
  if (!cartEl) return;

  const panel = $('.hds-cart__panel', cartEl);
  const itemsEl = $('#hds-cart-items', cartEl);
  const subtotalEl = $('#hds-cart-subtotal', cartEl);
  const progressTextEl = $('#hds-cart-progress-text', cartEl);
  const progressFillEl = $('#hds-cart-progress-fill', cartEl);

  // Read threshold from data attribute injected by section settings (fallback 50)
  let threshold = 50;
  // We’ll read it from the DOM by scraping the schema-generated span once we fetch cart
  function getThreshold() {
    // The text includes currency, but we want a number: we rely on the section setting passed to theme and stored here:
    // Safer: find a meta tag we inject (set below) OR fall back to 50
    const meta = document.querySelector('meta[name="hds-free-shipping-threshold"]');
    const n = meta ? Number(meta.getAttribute('content')) : NaN;
    threshold = isNaN(n) ? 50 : n;
  }

  function money(cents) {
    try { return Shopify.formatMoney(cents); } catch (e) {
      // fallback rough formatter
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  function openDrawer() {
    cartEl.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    cartEl.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function bindClose() {
    cartEl.addEventListener('click', (e) => {
      if (e.target.matches('[data-hds-cart-close]')) closeDrawer();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && cartEl.getAttribute('aria-hidden') === 'false') closeDrawer();
    });
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  function lineItemHTML(item) {
    const img = item.image ? `<img src="${item.image.replace('.jpg', '_180x.jpg')}" alt="${item.product_title}" class="hds-cart__item-img" loading="lazy">` : '';
    const options = item.options_with_values && item.options_with_values.length
      ? `<div class="hds-cart__item-opts">${item.options_with_values.map(o => `${o.name}: ${o.value}`).join(' • ')}</div>` : '';
    return `
      <div class="hds-cart__item" data-key="${item.key}">
        <a href="${item.url}" class="hds-cart__item-media">${img}</a>
        <div class="hds-cart__item-info">
          <a href="${item.url}" class="hds-cart__item-title">${item.product_title}</a>
          ${options}
          <div class="hds-cart__item-bottom">
            <div class="hds-qty">
              <button type="button" class="hds-qty__btn" data-change="-1" aria-label="Decrease quantity">-</button>
              <input type="text" class="hds-qty__input" value="${item.quantity}" inputmode="numeric" pattern="[0-9]*" aria-label="Quantity">
              <button type="button" class="hds-qty__btn" data-change="1" aria-label="Increase quantity">+</button>
            </div>
            <div class="hds-cart__item-price">${money(item.line_price)}</div>
          </div>
          <button class="hds-cart__remove" type="button" aria-label="Remove" data-remove>Remove</button>
        </div>
      </div>`;
  }

  function render(cart) {
    // Items
    itemsEl.innerHTML = cart.items.length
      ? cart.items.map(lineItemHTML).join('')
      : `<p class="hds-cart__empty">Your cart is empty.</p>`;

    // Subtotal
    subtotalEl.textContent = money(cart.items_subtotal_price);

    // Progress
    const subtotal = cart.items_subtotal_price / 100;
    const remaining = Math.max(0, threshold - subtotal);
    const pct = Math.max(0, Math.min(100, (subtotal / threshold) * 100));
    progressFillEl.style.width = `${pct}%`;
    progressTextEl.textContent = remaining > 0
      ? `You’re ${money(Math.round(remaining * 100))} away from free shipping`
      : `🎉 You’ve unlocked free shipping!`;

    bindItemControls();
  }

  function bindItemControls() {
    // Quantity +/- and remove
    itemsEl.querySelectorAll('.hds-qty__btn').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const itemEl = e.target.closest('.hds-cart__item');
        const key = itemEl.getAttribute('data-key');
        const input = itemEl.querySelector('.hds-qty__input');
        const change = Number(e.currentTarget.getAttribute('data-change'));
        let qty = Math.max(0, Number(input.value) + change);
        await updateItem(key, qty);
      });
    });

    itemsEl.querySelectorAll('.hds-qty__input').forEach(input => {
      input.addEventListener('change', async (e) => {
        const itemEl = e.target.closest('.hds-cart__item');
        const key = itemEl.getAttribute('data-key');
        let qty = Math.max(0, parseInt(e.target.value || '0', 10));
        await updateItem(key, qty);
      });
    });

    itemsEl.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const itemEl = e.target.closest('.hds-cart__item');
        const key = itemEl.getAttribute('data-key');
        await updateItem(key, 0);
      });
    });
  }

  async function updateItem(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await fetchCart();
    render(cart);
  }

  async function addToCart(form) {
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    });
    if (!res.ok) {
      // Optional: show an error toast
      return;
    }
    const cart = await fetchCart();
    render(cart);
    openDrawer();
  }

  function hijackAddToCart() {
    // Intercept any form that posts to /cart/add
    document.addEventListener('submit', function (e) {
      const form = e.target;
      const action = form.getAttribute('action') || '';
      if (action.includes('/cart/add')) {
        e.preventDefault();
        addToCart(form);
      }
    });
  }

  async function init() {
    getThreshold();
    bindClose();
    hijackAddToCart();
    // Load current cart state so drawer is ready
    try {
      const cart = await fetchCart();
      render(cart);
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', init);
})();
